import React from 'react';

import "./css/coolLoader.css";
import {getArr} from "./baseFunctions";
//import world from "./images/world-map5.svg";
class CoolLoader extends React.Component {
	render(){
		if(!this.props.show)
		{
			return false;
		}
		const data = {
			"table": 10,
			"graph": 47,
		};
		var world = require("./images/world-map5.svg");
		return (<div className={"animated-background " + this.props.type} style={this.props.style || {}}>
              <div className="background-masker header-top"></div>
              {
              	this.props.type === "worldMap" ? <img src={world} className="map"/> : ""
              }
              
              {
                getArr(data[this.props.type]).map((d, key) => <div key={"line" + key} className={"background-masker line-" + (key + 1)}></div>)
              }
           </div>);
	}
}

export default CoolLoader;


// WEBPACK FOOTER //
// ./src/components/CoolLoader.js